export default {
	// 获取图片
	$img(path,local){
		if( path ){
			if(path.substring(0,4)=='http'){
				return path;
			}else{
				return $config.apihost +'/'+ path;
			}
		}else{
			return '';
		}
	},
	$navto(url){
		this.$router.replace(url);
	},
	$warning(msg){
		this.$message({message: msg, type: 'warning'});
	},
	$success(msg){
		this.$message({message: msg, type: 'success'});
	},
	$load(flag){
		if( !flag ){
			this.$loading().close();
		}else{
			this.$loading({lock: true, text: 'Loading', spinner: 'el-icon-loading'});
		}
	},
	$getCurrentTime(){
		const now = new Date();
		const year = now.getFullYear();
		const month = String(now.getMonth() + 1).padStart(2, '0');
		const day = String(now.getDate()).padStart(2, '0');
		const hours = String(now.getHours()).padStart(2, '0');
		const minutes = String(now.getMinutes()).padStart(2, '0');
		const seconds = String(now.getSeconds()).padStart(2, '0');
		return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
	},
}